export default __webpack_public_path__ + "static/media/Leggings of Concealing Shadows.c5487847.jpg";